import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { ConstantsService } from '@app/services/constantsService';
import './v-popup.component.scss';

@Component({
    selector: 'v-popup',
    template: require('./v-popup.component.html')
})
export class VPopupComponent {
    @HostBinding('class.show')  @Input() mouseEvent: MouseEvent;
    @HostBinding('class.show-on-right')  @Input() showOnRight: boolean;

    //--

    isMobile: boolean;
    showCenter: boolean;
    constructor(
        private readonly el: ElementRef<HTMLElement>,
        private readonly constantsService: ConstantsService) { }

    ngOnInit(): void {
        this.isMobile = this.constantsService.getIsMobile();
        if (this.isMobile) {
            this.showCenter = true;
        }
    }

    ngOnChanges(): void {
        if (!this.mouseEvent) {
            return;
        }

        this.updatePosition();
    }

    //--

    private updatePosition(): void {
        const thisBounds = this.el.nativeElement.getBoundingClientRect();
        const targetBounds = (this.mouseEvent?.target as HTMLElement)?.getBoundingClientRect();

        this.el.nativeElement.style.left = targetBounds.right + 'px';
        this.el.nativeElement.style.top = targetBounds.top + 'px';


        //if (thisBounds.bottom > window.innerHeight) {
        //    this.el.nativeElement.style.top = (window.innerHeight - thisBounds.height) + "px";
        //}
    }
}
